module.exports = __webpack_public_path__ + "img/franc-sign.22c4f1cc.svg";